import script from "./FieldsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldsForm.vue?vue&type=script&setup=true&lang=js"

import "./FieldsForm.vue?vue&type=style&index=0&id=19fc96b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19fc96b6"]])

export default __exports__